import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperComponent } from './stepper/stepper.component';
import { AtomsModule } from '../atoms';
import { AlertComponent } from './alert/alert.component';

const ELEMENTS = [StepperComponent, AlertComponent];

@NgModule({
  imports: [CommonModule, AtomsModule],
  declarations: [...ELEMENTS],
  exports: [...ELEMENTS],
})
export class MoleculesModule {}
